/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { ALL_LANGUAGES } from './all-languages';

const codes = Object.keys(ALL_LANGUAGES) as [string, ...string[]];

export const languageCodeSchema = z.enum(codes);

export type ILanguageCode = z.infer<typeof languageCodeSchema>;
